var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostFrame',_vm._b({},'PostFrame',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('PostTitle',{attrs:{"post":_vm.post}}),_vm._v(" "),(_vm.showNsfwNotice)?_c('div',[_c('NsfwPost',{attrs:{"post":_vm.post}})],1):(_vm.isLoading)?_c('div',{staticClass:"post-loader"},[_c('rotate-loader')],1):_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21afe888","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post.vue
// module id = 4/iF
// module chunks = 1